// extracted by mini-css-extract-plugin
export default {"avatars":"User_avatars__WXtK6","image":"User_image__h9QDC"};